// Shared component styles. Preserve selector order, style values, and caller overrides.
export const companyCellStyles = {
  root: () => ({
    display: "flex",
    alignItems: "center",
    gap: 1,
    minWidth: 0
  }),
  logoImage: () => ({
    objectFit: "contain",
    padding: 3,
    boxSizing: "border-box"
  }),
  avatar: () => ({
    width: 30,
    height: 30,
    flexShrink: 0,
    bgcolor: "#FFFFFF",
    border: "1px solid #E5E7EB",
    color: "#9C4FFF",
    fontSize: 12
  }),
  text: () => ({
    minWidth: 0
  }),
  name: ({
    interactive
  }) => ({
    display: "block",
    maxWidth: "100%",
    m: 0,
    p: 0,
    border: 0,
    bgcolor: "transparent",
    textAlign: "left",
    fontFamily: "Be Vietnam Pro",
    fontSize: 14,
    lineHeight: "20px",
    fontWeight: 500,
    color: "#101828",
    textDecoration: "none",
    cursor: interactive ? "pointer" : "inherit",
    "&:hover": interactive ? {
      textDecoration: "underline"
    } : {},
    "&:focus-visible": {
      outline: "2px solid #9C4FFF",
      outlineOffset: 2
    }
  }),
  website: () => ({
    display: "block",
    fontFamily: "Be Vietnam Pro",
    fontSize: 14,
    lineHeight: "20px",
    fontWeight: 500,
    color: "#98A2B3",
    textDecoration: "none"
  })
};
